import { BREAKPOINT } from '@angular/flex-layout';

const MHM_BREAKPOINTS = [
  {
    alias: 'gt-xs',
    suffix: 'GtXS',
    mediaQuery: 'screen and (min-width: 1024px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'gt-sm',
    suffix: 'GtSM',
    mediaQuery: 'screen and (min-width: 1280px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'gt-md',
    suffix: 'GtMD',
    mediaQuery: 'screen and (min-width: 1440px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'gt-lg',
    suffix: 'GtLG',
    mediaQuery: 'screen and (min-width: 1600px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'xs',
    suffix: 'XS',
    mediaQuery: 'screen and (max-width: 1023px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'sm',
    suffix: 'SM',
    mediaQuery: 'screen and (min-width: 1024px) and (max-width: 1439px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'md',
    suffix: 'MD',
    mediaQuery: 'screen and (min-width: 1440px) and (max-width: 1599px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'lg',
    suffix: 'LG',
    mediaQuery: 'screen and (min-width: 1600px) and (max-width: 1919px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'xl',
    suffix: 'XL',
    mediaQuery: 'screen and (min-width: 1920px) and (max-width: 5000px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'lt-sm',
    suffix: 'LtSM',
    mediaQuery: 'screen and (max-width: 1279px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'lt-md',
    suffix: 'LtMD',
    mediaQuery: 'screen and (max-width: 1339px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'lt-lg',
    suffix: 'LtLG',
    mediaQuery: 'screen and (max-width: 1500px)',
    overlapping: false,
    priority: 1001
  },
  {
    alias: 'lt-xl',
    suffix: 'LtXL',
    mediaQuery: 'screen and (max-width: 1919px)',
    overlapping: false,
    priority: 1001
  }
];

export const CustomBreakPointsProvider = {
  provide: BREAKPOINT,
  useValue: MHM_BREAKPOINTS,
  multi: true,
  standalone: true
};
